@if (textUpozorneni) {
  <!-- výstražná karta úvodní stránky (barvy z tokenů gov-theme, stav warning); na telefonu ikona nad textem -->
  <div
    class="flex items-center bg-(--background-status-warning-subtlest) text-(--text-status-warning) border border-(--border-warning) whitespace-pre-line py-2.5 pr-0 pl-12.5 max-md:flex-col max-md:items-start max-md:gap-2 max-md:p-4">
    <i
      class="pi pi-exclamation-triangle text-(--icon-warning) pr-12.5 text-[4rem] max-md:pr-0 max-md:text-(length:--icon-size-4xl)"></i>
    <span>{{ textUpozorneni }}</span>
  </div>
}
